// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_record.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.GetProposalRecordHeaderRequest
 */ export class GetProposalRecordHeaderRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalRecordHeaderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalRecordHeaderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalRecordHeaderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalRecordHeaderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalRecordHeaderRequest, "runtime", proto3);
_define_property(GetProposalRecordHeaderRequest, "typeName", "mono.projectdata.v1.GetProposalRecordHeaderRequest");
_define_property(GetProposalRecordHeaderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Counts are over current-version, non-removed rows only. A count the caller
 * may not see is 0 and the FE hides the badge (never a placeholder).
 *
 * @generated from message mono.projectdata.v1.ProposalNavCounts
 */ export class ProposalNavCounts extends Message {
    static fromBinary(bytes, options) {
        return new ProposalNavCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalNavCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalNavCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalNavCounts, a, b);
    }
    constructor(data){
        super(), /**
   * GetProjectGovConSnapshot.compliance_stats.total_requirements
   *
   * @generated from field: int32 requirements = 1;
   */ _define_property(this, "requirements", 0), /**
   * ListProposalReviews rows with status == "open"
   *
   * @generated from field: int32 open_reviews = 2;
   */ _define_property(this, "openReviews", 0), /**
   * GetProjectGovConSnapshot.total_source_documents
   *
   * @generated from field: int32 files = 3;
   */ _define_property(this, "files", 0), /**
   * current CLINs (is_current_version && amendment_status != "REMOVED"); 0 without pricing read
   *
   * @generated from field: int32 clins = 4;
   */ _define_property(this, "clins", 0), /**
   * current LCATs (same filter); 0 without pricing read
   *
   * @generated from field: int32 lcats = 5;
   */ _define_property(this, "lcats", 0), /**
   * sum(CarriedInRow.count) visible to the caller (PRP-04); 0 when no pursuit
   *
   * @generated from field: int32 carried_in = 6;
   */ _define_property(this, "carriedIn", 0), /**
   * GetProjectGovConSnapshot.total_amendments
   *
   * @generated from field: int32 amendments = 7;
   */ _define_property(this, "amendments", 0), /**
   * ListProposalDocuments total visible to the caller (PRP-20)
   *
   * @generated from field: int32 documents = 8;
   */ _define_property(this, "documents", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalNavCounts, "runtime", proto3);
_define_property(ProposalNavCounts, "typeName", "mono.projectdata.v1.ProposalNavCounts");
_define_property(ProposalNavCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "open_reviews",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "files",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "clins",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "lcats",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "carried_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "amendments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "documents",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalPursuitLink
 */ export class ProposalPursuitLink extends Message {
    static fromBinary(bytes, options) {
        return new ProposalPursuitLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalPursuitLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalPursuitLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalPursuitLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * pursuit name
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * "/capture/{capture_project_id}"
   *
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * pursuit | direct | legacy_conversion (govcon.proposal_openings)
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalPursuitLink, "runtime", proto3);
_define_property(ProposalPursuitLink, "typeName", "mono.projectdata.v1.ProposalPursuitLink");
_define_property(ProposalPursuitLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalRecordHeaderResponse
 */ export class GetProposalRecordHeaderResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalRecordHeaderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalRecordHeaderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalRecordHeaderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalRecordHeaderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * proposal (project) name
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * ProposalInfo.solicitation_number
   *
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * RFC3339 UTC, "" when unset
   *
   * @generated from field: string due_at = 4;
   */ _define_property(this, "dueAt", ""), /**
   * IANA, "" when unstated (PRP-03 column)
   *
   * @generated from field: string due_timezone = 5;
   */ _define_property(this, "dueTimezone", ""), /**
   * unset: direct proposal OR caller cannot read the pursuit
   *
   * @generated from field: mono.projectdata.v1.ProposalPursuitLink pursuit = 6;
   */ _define_property(this, "pursuit", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalNavCounts counts = 7;
   */ _define_property(this, "counts", void 0), /**
   * verifyWriteAccess passes
   *
   * @generated from field: bool can_edit_proposal = 8;
   */ _define_property(this, "canEditProposal", false), /**
   * pricingReadGate passes (§3.3 canReadPricing)
   *
   * @generated from field: bool can_read_pricing = 9;
   */ _define_property(this, "canReadPricing", false), /**
   * pricingWriteGate passes (§3.3 canEditPricing)
   *
   * @generated from field: bool can_edit_pricing = 10;
   */ _define_property(this, "canEditPricing", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalRecordHeaderResponse, "runtime", proto3);
_define_property(GetProposalRecordHeaderResponse, "typeName", "mono.projectdata.v1.GetProposalRecordHeaderResponse");
_define_property(GetProposalRecordHeaderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "due_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pursuit",
            kind: "message",
            T: ProposalPursuitLink
        },
        {
            no: 7,
            name: "counts",
            kind: "message",
            T: ProposalNavCounts
        },
        {
            no: 8,
            name: "can_edit_proposal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "can_read_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "can_edit_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
